<template>
    <div>

        <div class="header-return">
            <el-row :gutter="20">
                <el-col :span="2">
                    <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
                </el-col>
                <el-col :span="2" :offset="20">
                    <el-button type="success" :size="GCONFIG.styleElFormSize" @click="handleAdd">新增</el-button>
                </el-col>
            </el-row>
        </div>
        <el-table :data="conditionList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading">
            <!--  <el-table-column type="selection" width="55"></el-table-column>-->
            <el-table-column type="index" label="序号" width="60"></el-table-column>
            <el-table-column prop="level" label="等级编号" width="200"></el-table-column>
            <el-table-column prop="levelName" label="等级名称" width="200"></el-table-column>
            <el-table-column prop="orderNum" label="等级类型">
                <template slot-scope="scope">
                    <span v-if="scope.row.levelType==1">订单升级，要求订单数：{{scope.row.orderNum}}</span>
                    <span v-if="scope.row.levelType==2">付费升级，对应活动BindCode：{{scope.row.bindCode}}</span>

                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="300">
                <template slot-scope="scope">
                    <selectPicComponents
                            :selectImages="{'proId':scope.row.id,'picType':201,'proName':scope.row.level,'limitCount':1,'btnText':'升级后弹窗'}"></selectPicComponents>
                    <el-button type="primary" size="mini" @click="handleEdit(scope.row)">修改</el-button>
                    <el-button type="success" size="mini" @click="handleAddFree(scope.row)">赠品</el-button>
                    <!--                    <el-button type="warning " size="mini" @click="handleDel(scope.row)">删除</el-button>-->
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>
        <el-dialog title="添加会员等级" :visible.sync="dialogFormVisible" center>
            <el-form :model="form" label-width="120px">
                <el-form-item label="等级">
                    <el-input-number v-model="form.level" :min="1" :max="1000" :step="1" placeholder="等级"></el-input-number>
                </el-form-item>
                <el-form-item label="等级名称">
                    <el-input v-model="form.levelName" placeholder="等级名称"></el-input>
                </el-form-item>
                <el-form-item label="会员类型">
                    <el-radio-group v-model="form.levelType" @change="changeLevelType">
                        <el-radio :label="1">订单升级</el-radio>
                        <el-radio :label="2">付费升级</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="要求订单数" v-show="form.levelType==1">
                    <el-input-number v-model="form.orderNum" :min="1" :max="1000" :step="1" placeholder="要求订单数"></el-input-number>
                </el-form-item>
                <el-form-item label="对应活动" v-show="form.levelType==2">
                    <el-select v-model="form.bindCode" placeholder="请选择">
                        <el-option
                                v-for="item in activeList"
                                :key="item.bindCode"
                                :label="item.activeName"
                                :value="item.bindCode">
                        </el-option>
                    </el-select>

                </el-form-item>
                <el-form-item label="升级周期" v-show="form.levelType==2">
                    <el-input-number v-model="form.period" :min="1" :max="1000" :step="1" placeholder="升级周期"></el-input-number>
                </el-form-item>
                <el-form-item label="周期单位" v-show="form.levelType==2">
                    <el-select v-model="form.periodUnit" placeholder="请选择">
                        <el-option
                                v-for="item in periodUnitList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="addCondition(form)">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {conditionList, saveCondition, delCondition, getActiveForOptionListByType} from '../../api/api'
    import selectPicComponents from '@/components/selectPic';
    //定义组件
    export default{
        data(){
            return {
                conditionList: [],
                periodUnitList: [{"id": 1, "name": "年"}, {"id": 2, "name": "月"}, {"id": 3, "name": "日"}],
                activeList: [],//bindCode的select
                loading: true,
                selectValue: '',

                dialogFormVisible: false,
                form: {
                    "id": "",
                    "level": "",
                    "levelName": "",
                    "orderNum": "",
                    "levelType": null,
                    "bindCode": "",
                    "period": null,
                    "periodUnit": null,
                },
                formInline: {
                    currentPage: 1,
                    recordsTotal: 0,
                    pageSize: 10,
                }
            }
        },
        components: {
            selectPicComponents
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.getList();
            //初始化活动列表, 付费会员，activeType=49
            this.getActiveList(49)
            this.getActiveList(53)
        },
        methods: {
            //定义查询方法
            getList(){
                this.loading = true;
                conditionList(this.formInline).then((res) => {
                    this.loading = false;
                    this.conditionList = res.data.list;
                    this.formInline.recordsTotal = res.data.total;
                })
            },
            getActiveList(activeType){
                getActiveForOptionListByType({"activeType": activeType}).then((res) => {
                    console.log(res.data.value);
                    for (let item of res.data.value) {
                        this.activeList.push(item)
                    }

                });
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList();
            },
            handleEdit(row){

                this.form.id = row.id;
                this.form.level = row.level;
                this.form.levelName = row.levelName;
                this.form.orderNum = row.orderNum;
                this.form.bindCode = row.bindCode;
                this.form.levelType = row.levelType;
                this.form.period = row.period;
                this.form.periodUnit = row.periodUnit;
                this.dialogFormVisible = true;
                this.orderPayVisible = row.levelType == 2;
                this.orderNumberVisible = row.levelType == 1;
            },
            handleDel(row){
                this.$confirm('删除等级, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delCondition({id: row.id}).then((res) => {
                        if (res.data.status == 200) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList(this.currentPage, this.pageSize);
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {

                });
            },
            handleAdd(){
                this.form = {}
                this.dialogFormVisible = true;
            },
            addCondition(form){
                //以此判断level、levelName、levelType、period、periodUnit必填

                if (form.level == '') {
                    this.$message({
                        showClose: true,
                        message: "会员级别必填",
                        type: 'error'
                    });
                    return;
                }
                if (form.levelName == '') {
                    this.$message({
                        showClose: true,
                        message: "会员名称必填",
                        type: 'error'
                    });
                    return;
                }
                if (form.levelType == '') {
                    this.$message({
                        showClose: true,
                        message: "会员类型必填",
                        type: 'error'
                    });
                    return;
                }
                if (form.levelType == 2) {
                    if (form.bindCode == '') {
                        this.$message({
                            showClose: true,
                            message: "活动必选",
                            type: 'error'
                        });
                        return;
                    }
                    if (form.period == '') {
                        this.$message({
                            showClose: true,
                            message: "会员周期必填",
                            type: 'error'
                        });
                        return;
                    }
                    if (form.periodUnit == '') {
                        this.$message({
                            showClose: true,
                            message: "会员周期单位必填",
                            type: 'error'
                        });
                        return;
                    }
                } else {
                    if (form.orderNum == '') {
                        this.$message({
                            showClose: true,
                            message: "订单数必填",
                            type: 'error'
                        });
                        return;
                    }
                }


                //判断当levelType=1时orderNum必填，levelType=2时bindCode必填


                saveCondition(form).then((res) => {
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.dialogFormVisible = false;
                        this.getList(this.currentPage, this.pageSize);
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            changeLevelType(val){
                console.log(val);
                if (val == "1") {
                    this.form.bindCode = "";
                    this.form.period = null;
                    this.form.periodUnit = null;
                    //禁用下拉框
                    //this.orderPayVisible=false;

                    //启用输入框
                    // this.orderNumberVisible = true;

                }
                if (val == "2") {
                    this.form.orderNum = "";

                    // this.orderNumberVisible = false;

                    // this.orderPayVisible= true;

                }

            },
            handleAddFree(row){
                //batchId : row.batchId,
                //batchFreeList
                this.$router.push({
                    path: '/CardBatchFree/:source/:batchId',
                    name: 'CardBatchFree',
                    params: {source: 2, batchId: row.level}
                });
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/vip/vipConditionList.vue